module.exports = __webpack_public_path__ + "img/Find_your_school_revised.fed734d4.svg";